import styled from '@emotion/styled';
import { facebookBlue, whatsappGreen } from '@/colors/colorsV1';
import { color, sizing } from '../styled-system';

const BaseShareButton = styled.div`
  padding: 0;
  font: inherit;
  cursor: pointer;
  width: 100%;
  border-radius: 8px;
  color: #ffffff;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  line-height: normal;
  box-shadow: none;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.05em;
  ${sizing}
`;

export const StyledFaceBookShareButton = styled(BaseShareButton)`
  background-color: ${facebookBlue};
  ${color}
`;

export const StyledWhatsAppShareButton = styled(BaseShareButton)`
  background-color: ${whatsappGreen};
  ${color}
`;

export const StyledImage = styled.img`
  height: 16px;
  width: 16px;
  margin-right: 8px;
`;
